module.exports = __webpack_public_path__ + "img/TNG-argument1.6d34029.svg";